module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid login"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-10 col-sm-8 mx-auto login-form"
  }, [_c('router-link', {
    staticClass: "content-logo-principal",
    attrs: {
      "to": "/"
    }
  }, [_c('div', [_c('h1', [_c('a', {
    attrs: {
      "href": "https://royalpag.com/"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "250px !important",
      "width": "250px"
    },
    attrs: {
      "src": _vm.img
    }
  })])])])]), _vm._v(" "), (!_vm.senhaAlterada) ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n              Redefina a sua senha!\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center text-default-gray",
    staticStyle: {
      "font-size": "14px",
      "font-family": "Roboto",
      "margin-bottom": "0px !important"
    }
  }, [_vm._v("Preencha os campos abaixo para redefinir sua senha.")]), _vm._v(" "), _c('div', {
    staticClass: "card-body pt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    staticClass: "well",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.senha),
      expression: "usuario.senha"
    }],
    staticClass: "form-control here",
    class: {
      invalid: _vm.$v.usuario.senha.$error
    },
    attrs: {
      "placeholder": "Senha",
      "type": "password"
    },
    domProps: {
      "value": (_vm.usuario.senha)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "senha", $event.target.value)
      }, function($event) {
        return _vm.$v.usuario.senha.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.usuario.senha.$dirty && !_vm.$v.usuario.senha.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Campo obrigatório!")]) : _vm._e(), _vm._v(" "), (_vm.$v.usuario.senha.required && !_vm.$v.usuario.senha.minLength) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Senha mínimo " + _vm._s(_vm.$v.usuario.senha.$params.minLength.min) + " caracteres")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.senhaVerificacao),
      expression: "senhaVerificacao"
    }],
    staticClass: "form-control here",
    class: {
      invalid: _vm.$v.senhaVerificacao.$error
    },
    attrs: {
      "placeholder": "Senha novamente",
      "type": "password"
    },
    domProps: {
      "value": (_vm.senhaVerificacao)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.senhaVerificacao = $event.target.value
      }, function($event) {
        return _vm.$v.senhaVerificacao.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.senhaVerificacao.$dirty && !_vm.$v.senhaVerificacao.required) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Campo obrigatório!")]) : _vm._e(), _vm._v(" "), (_vm.$v.senhaVerificacao.required && !_vm.$v.senhaVerificacao.minLength) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Senha mínimo " + _vm._s(_vm.$v.senhaVerificacao.$params.minLength.min) + " caracteres")]) : _vm._e(), _vm._v(" "), (_vm.$v.senhaVerificacao.required && _vm.$v.senhaVerificacao.minLength && !_vm.$v.senhaVerificacao.isOk) ? _c('span', {
    staticClass: "invalid"
  }, [_vm._v("Senhas não conferem.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block mb-3",
    attrs: {
      "type": "submit",
      "value": "Recuperar",
      "disabled": !_vm.isWholeModelValid
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v("Lembrou a senha? "), _c('router-link', {
    attrs: {
      "to": "/auth/login",
      "exact": ""
    }
  }, [_vm._v("Voltar")])], 1)])])])])])]) : _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 pb-5",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n              Senha alterada com sucesso!\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block",
    style: (_vm.color),
    attrs: {
      "type": "reset",
      "value": "Entrar"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.voltar.apply(null, arguments)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isWholeRedirect),
      expression: "!isWholeRedirect"
    }],
    staticClass: "form-group text-center pb-0 mb-0 text-default-gray",
    staticStyle: {
      "padding-top": "3px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.contador))])])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68be28ec","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/forgotPassword/reset.vue
// module id = KZvn
// module chunks = 36